module.exports = __webpack_public_path__ + "static/media/process_4.159b7460.png";